// extracted by mini-css-extract-plugin
export default {"language-switcher":"languageSwitcher_language-switcher__BZoNF","active":"languageSwitcher_active__EpK7B"};